module.exports = __webpack_public_path__ + "img/logo.f4cf3023.png";